<script setup lang="ts">
import { computed } from 'vue'
// @ts-expect-error module '@ui-kit/scripts/utils/date' is js and lacks type definitions
import dateUtils from '@ui-kit/scripts/utils/date'
import i18n from '@/scripts/app-configs/i18n-config'
import type { Reminder } from '@/components/drawers/MemberDrawer/types/member-drawer.types'

const props = defineProps<{
  items: Reminder[]
}>()

const buttonLabel = computed(() => {
  const total = props.items
    .map((item) => item.days_of_week || [])
    .reduce((accumulator, currentArray) => accumulator + currentArray.length, 0)

  if (!total) return i18n.t('SIDEBAR.REMINDERS_NONE')

  return total > 1 ? i18n.t('SIDEBAR.REMINDERS_VIEW_TOTAL', { total }) : i18n.t('SIDEBAR.REMINDERS_VIEW_1')
})

const formatTime = (hour: number, minute: number): string => {
  return dateUtils.formatTime(hour, minute)
}

const abbreviatedDays = (days: string[]): string => {
  return days.map((day) => abbreviateDayOfWeek(day)).join(', ')
}

const abbreviateDayOfWeek = (dayOfWeek: string, lang = i18n.locale): string => {
  const date = dateUtils.getNextDate(dayOfWeek)
  const options: Intl.DateTimeFormatOptions = { weekday: 'short' }
  let weekday = new Intl.DateTimeFormat(lang as string, options).format(date)

  weekday = weekday.replace('.', '')

  return weekday.charAt(0).toUpperCase() + weekday.slice(1)
}

</script>

<template>
  <sword-popover-wuk class="relative inline-block" :distance="10" placement="bottom-end">
    <sword-button-wuk
      theme="secondary"
      icon="schedule"
      size="small"
      side="left"
      :text="buttonLabel"
      :disabled="!items.length"
      class="!mt-2"
    />
    <template #content>
      <ul class="w-[19rem] py-2">
        <li
          v-for="(item, index) of items"
          :key="index"
          class="flex justify-between px-4 py-3 text-xs"
        >
          <span class="font-semibold">{{ formatTime(item.hour, item.min) }}</span>
          <span>{{ abbreviatedDays(item.days_of_week) }}</span>
        </li>
      </ul>
    </template>
  </sword-popover-wuk>
</template>
